import Vue from 'vue';
// 前置样式
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets
// 组件
import Element from 'element-ui';
import VueBarcode from '@xkeshi/vue-barcode';
import VueCustomScrollbar from 'vue-custom-scrollbar'; // v-scrollbar
// 插件
import uploader from 'vue-simple-uploader';
import eIconPicker, {
  analyzingIconForIconfont,
  iconList
} from 'e-icon-picker';
import 'e-icon-picker/dist/symbol.js'; // 基本彩色图标库
import Contextmenu from "vue-contextmenujs";
import VueAwesomeSwiper from 'vue-awesome-swiper'; // Swiper
import Print from 'vue-print-nb'; // vue-print-nb
import contextmenu from 'v-contextmenu'; // v-contextmenu
import fullscreen from 'vue-fullscreen';
import qs from 'qs'; // qs
import Vue2OrgTree from 'vue2-org-tree'; // 组织树
import 'xe-utils';
import localForage from 'localforage';
import dayjs from 'dayjs'; // dayjs
import isBetween from 'dayjs/plugin/isBetween';
import Sortable from 'sortablejs'; // Sortable
import VXETable from 'vxe-table'; // vxe-table
import echarts from '@/libs/echarts'; // 按需引入echarts，如果有新增图表或组件、属性使用，在里面添加引用（\node_modules\echarts\index.js里找）
// 本地
import App from '@/App';
import store from '@/store';
import router from '@/router';
import KlinxUI from '@klinx/components/packages/index';
import { vxeAddRenderer } from '@klinx/components/packages/common/ku-grid/add-renderer';
import {
  customValiate
} from '@klinx/utils/verifies';
import {
  newMessage,
  resetMessageList
} from '@klinx/utils/message';
import {
  hasAnyPermission,
  hasNoPermission,
  hasPermission,
  hasAnyRole,
  hasNoRole,
  hasRole
} from '@klinx/utils/permissionDirect';
import preventReClick from '@klinx/utils/preventReClick.js'; // 引入按钮防止点击
import elInitHeight from '@klinx/directives/el-height'; // elInitHeight
import '@/utils/error-log'; // error log
import * as filters from '@klinx/filters'; // global filters
import registerGlobalComp from '@/components/global'; // 本地组件全局注册
// import * as Sentry from "@sentry/vue";
// 后置样式
import 'v-contextmenu/dist/index.css';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';
import 'swiper/dist/css/swiper.min.css';
import 'e-icon-picker/dist/index.css'; // 基本样式，包含基本图标
import 'font-awesome/css/font-awesome.min.css'; // font-awesome 图标库
import 'element-ui/lib/theme-chalk/icon.css'; // element-ui 图标库，正常的不会被sass loader转义的样式
import 'vxe-table/lib/icon/style/style.css'; // vxe-table 图标库，正常的不会被sass loader转义的样式
import '@/styles/iconfont/iconfont.css'; // 自己的图标样式
import '@/styles/iconfont/iconsimple.css'; // 自己的单色图标样式
import '@/styles/iconfont/iconcolour.css'; // 自己的彩色图标样式
import '@/styles/iconfont/iconcolour2.css'; // 自己的彩色图标样式2
import '@/styles/iconfont/iconcolour3.css'; // 自己的彩色图标样式3
import '@/styles/iconfont/iconcolour4.css'; // 自己的彩色图标样式4
import '@/styles/iconfont/iconfonttag.css'; // 自己的单色图标样式
import '@klinx/components/packages/styles/iconfont/iconfontcolor2.css';
import '@/styles/font/hanzipen.css';
import '@/styles/common.scss';
import '@/styles/index.scss'; // global css

import i18n from '@/lang'; // internationalization
import '@/icons'; // icon
import iconfonts from '@/styles/iconfont/iconfont.json'; // 自己的图标样式
import iconsimple from '@/styles/iconfont/iconsimple.json'; // 自己的图标样式
import uiIconfonts from '@klinx/components/packages/styles/iconfont/iconfont.json'; // 自己的图标样式
import svgIcons from 'e-icon-picker/dist/getSvg';
import db from '@klinx/utils/localstorage';

/** 组件注册 **/
Vue.component('barcode', VueBarcode); // 条形码
Vue.component('v-scrollbar', VueCustomScrollbar);

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value),
  size: "small"
});

vxeAddRenderer(VXETable);

VXETable.setup({
  zIndex: 2100,
  i18n: (key, args) => i18n.t(key, args),
  table: { // 解决缩放窗口导致列宽错误
    autoResize: true,
    resizable: true,
    border: 'inner',
    showOverflow: true
  }
});

const Plugins = [
  VXETable, // vxe-table
  VueAwesomeSwiper,
  registerGlobalComp,
  preventReClick,
  customValiate,
  elInitHeight,
  Print,
  contextmenu, // v-contextmenu
  Contextmenu, // contextMenuJs
  Vue2OrgTree,
  KlinxUI,
  uploader,
  fullscreen,
  qs,
  hasPermission,
  hasNoPermission,
  hasAnyPermission,
  hasAnyRole,
  hasNoRole,
  hasRole
];
Plugins.map((plugin) => {
  Vue.use(plugin);
});

// vue原型拓展，给 vue 实例挂载内部对象，例如：
dayjs.extend(isBetween);
Vue.prototype.dayjs = dayjs;
Vue.prototype.$XModal = VXETable.modal;
Vue.prototype.$XPrint = VXETable.print;
Vue.prototype.$XSaveFile = VXETable.saveFile;
Vue.prototype.$XReadFile = VXETable.readFile;
Vue.prototype.$eventBus = new Vue(); // eventBus
Vue.prototype.$echarts = echarts;
Vue.prototype.$Sortable = Sortable;
Vue.prototype.$deleteArray = Vue.prototype.$delete;
Vue.prototype.$forage = localForage;
Vue.prototype.$getEnvConfig = function(key) {
  const envCfg = db.get('ENV_CONFIG') || {};
  if (envCfg[key] !== undefined) {
    return envCfg[key];
  }
  return process.env[key] || '';
};
// 复写message api
Vue.prototype.$Message = function(msg, t, d, o, close) {
  newMessage({
    message: msg,
    type: t,
    duration: d || 1000,
    showClose: close || false,
    offset: o || 100
  });
};
Vue.prototype.$message = newMessage;
// 重置全局 Message 提示记录（接口各种提示相关）
resetMessageList();

// 全局删除增加图标
const forIconfont = analyzingIconForIconfont(iconfonts);
const forSimpleIconfont = analyzingIconForIconfont(iconsimple);
const forUIIconfonts = analyzingIconForIconfont(uiIconfonts);
Vue.use(eIconPicker, {
  FontAwesome: true,
  ElementUI: true,
  eIcon: true, // 自带的图标，来自阿里妈妈
  eIconSymbol: true, // 是否开启彩色图标
  addIconList: [...forIconfont.list, ...forSimpleIconfont.list, ...forUIIconfonts.list],
  removeIconList: []
});
iconList.addIcon(svgIcons);
// iconList.removeIcon(["el-icon-s-ticket"]);

// 全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 移除el-radio报错指令
Vue.directive('removeAriaHidden', {
  bind(el) {
    setTimeout(() => {
      const ariaEls = [...el.querySelectorAll('.el-radio__original'), ...el.querySelectorAll('.el-popover')];
      ariaEls.forEach((item) => {
        item.removeAttribute('aria-hidden');
      });
    }, 1000);
  }
});

Vue.config.productionTip = false;

// build开监控，本地调试不开
// process.env.VUE_APP_IS_BUILD === 'true' && process.env.VUE_APP_ENV !== 'dev' && Sentry.init({
//   Vue,
//   environment: process.env.VUE_APP_TENANT_ENV || process.env.VUE_APP_ENV,
//   dsn: `${window.location.protocol}//${process.env.VUE_APP_SENTRY_DSN}@${window.location.protocol.includes('https') ? window.location.host : '202.105.21.103:30090'}/2`,
//   release: process.env.VUE_APP_RELEASE,
//   integrations: [
//     Sentry.browserTracingIntegration({ router }),
//     Sentry.replayIntegration()
//   ],
//   // Tracing
//   tracesSampleRate: process.env.VUE_APP_ENV === 'sit' ? 0.5 : 0.005, // 常规采集频率，降低正式环境的采集，降低服务器负荷
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ['localhost', 'itexcloud.sit.itexpaas.com', '10.0.0.16', 'cloud.itexplat.com'],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   beforeSend(event, hint) {
//     const ignoreErrHints = [
//       'Request failed with status code',
//       'Cannot read properties of null (reading \'_t\')', // i18n偶发问题，离开页面偶发找不到
//       'Cannot read property \'_t\' of null',
//       'Loading chunk',
//       'Loading CSS',
//       'Network Error',
//       'timeout of',
//       'The connection has not been established yet',
//       'Request aborted',
//       'Non-Error promise rejection captured with value: cancel'
//     ];
//     if (event?.exception && ignoreErrHints.some(msg => event.exception.values[0]?.value.includes(msg))) {
//       return null;
//     }
//     if (hint?.originalException?.message && ignoreErrHints.some(msg => hint.originalException.message.includes(msg))) {
//       return null;
//     }
//     return event;
//   }
// });

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});
